import React, { useState, useEffect, useRef } from 'react';
import { isSbsApp } from '../../../common/utils/passUtil';

export default function ChannelTab24tv({ channels, onChannelChange }) {
  const [isRender, setIsRender] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentChannelId, setCurrentChannelId] = useState(null);

  const handleClick = (channelId) => {
    setCurrentChannelId(channelId);
    setIsExpanded(false);
    if (onChannelChange) {
      onChannelChange(channelId);
    }
  };
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setIsRender(true);
  }, []);

  useEffect(() => {
    if (!currentChannelId) {
      const path = window.location.pathname;
      const channelIdFromUrl = path.split('/').pop();
      const isValidChannelId = channels.some(
        (channel) => channel.channelid === channelIdFromUrl
      );
      const newChannelId = isValidChannelId ? channelIdFromUrl : '';

      if (newChannelId !== currentChannelId) {
        setCurrentChannelId(newChannelId);
      }
    }
  }, [channels, currentChannelId]);

  return (
    isRender && (
      <div className={`tabList_w02 ${isExpanded ? 'current' : ''}`}>
        <style>{`
			body {
				overflow: hidden;
			}
			`}</style>
        <div className="tabList_inner">
          <div className="tabList_scroll">
            {channels
              .sort((a, b) =>
                a.channelid === currentChannelId
                  ? -1
                  : b.channelid === currentChannelId
                  ? 1
                  : 0
              )
              .map((channel, index) => (
                <a
                  key={channel.channelid || index}
                  className={`btnLine01 ${
                    channel.channelid === currentChannelId ? 'active' : ''
                  }`}
                  onClick={() => handleClick(channel.channelid)}
                >
                  <span>{channel.desc}</span>
                </a>
              ))}
          </div>
        </div>
        <button
          type="button"
          className={`btnIcon02_more_toggle ${isExpanded ? 'active' : ''}`}
          onClick={toggleExpand}
        >
          {/* 버튼 활성화 '_toggle' 에 addclassName="active" */}
          <span className="ico_arrow01_on">
            <i className="ir">전체리스트 닫기</i>
          </span>
          <span className="ico_arrow01_off">
            <i className="ir">전체리스트 보기</i>
          </span>
        </button>
      </div>
    )
  );
}
